<template>
    <modal :name="name" height="auto" :reset="true" :draggable="false">
        <div class="modal-header">
            {{ modalTitle }}
        </div>
        <div class="modal-body">
            <p class="mb-3">{{ confirmMessage }}</p>

            <div
                v-if="examRiskWarning"
                class="alert alert-warning exam-risk-warning"
                role="alert"
            >
                <strong class="d-block mb-2">{{
                    texts.required_lesson_warning_title
                }}</strong>
                <div>{{ examRiskWarning }}</div>
            </div>

            <div v-if="event.is_recurring">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="radio"
                        name="deleteEventRadios"
                        id="deleteThisEvent"
                        value="this-event"
                        v-model="deleteType"
                    />
                    <label class="form-check-label" for="deleteThisEvent">
                        {{ texts.delete_this_event }}
                    </label>
                </div>
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="radio"
                        name="deleteEventRadios"
                        id="deleteThisAndFollowingEvents"
                        value="this-and-following-events"
                        v-model="deleteType"
                    />
                    <label
                        class="form-check-label"
                        for="deleteThisAndFollowingEvents"
                    >
                        {{ texts.delete_this_and_following_events }}
                    </label>
                </div>
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="radio"
                        name="deleteEventRadios"
                        id="deleteAllEvents"
                        value="all-events"
                        v-model="deleteType"
                    />
                    <label class="form-check-label" for="deleteAllEvents">
                        {{ texts.delete_all_events }}
                    </label>
                </div>
            </div>
        </div>
        <div class="modal-footer pull-right">
            <button
                type="button"
                class="btn btn-link"
                @click="hide"
                :disabled="isDeleting"
            >
                {{ texts.cancel }}
            </button>
            <button
                type="button"
                class="btn btn-danger"
                @click="deleteEventConfirm"
                :disabled="isDeleting"
            >
                {{ deleteButtonText }}
            </button>
        </div>
    </modal>
</template>

<script>
import ModalBase from "./ModalBase.vue";

export default {
    extends: ModalBase,

    props: {},

    data() {
        return {
            event: {},
            date: moment(),
            deleteType: "this-event",
            examRiskWarning: null,
            confirmExamRisk: false,
            isDeleting: false,
        };
    },

    mounted() {
        console.log("Timetable Delete Event Modal Component Mounted.");
        this.eventBus.$on("delete-event", this.deleteEvent);
        this.eventBus.$on(
            "delete-event-requires-confirmation",
            this.handleDeleteRequiresConfirmation
        );
        this.eventBus.$on("deleted-event", this.handleDeletedEvent);
        this.eventBus.$on("delete-event-failed", this.handleDeleteEventFailed);
    },

    methods: {
        deleteEvent(event, date) {
            this.event = event;
            this.date = moment(date)
                .hour(event._start_hour)
                .minute(event._start_minute);
            this.deleteType = "this-event";
            this.examRiskWarning = null;
            this.confirmExamRisk = false;
            this.isDeleting = false;
            this.show();
        },

        deleteEventConfirm() {
            this.isDeleting = true;
            this.eventBus.$emit(
                "delete-event-confirm",
                this.event,
                this.date,
                this.deleteType,
                this.confirmExamRisk
            );
        },

        handleDeleteRequiresConfirmation(event, date, deleteType, response) {
            if (event.id !== this.event.id) {
                return;
            }

            this.date = moment(date);
            this.deleteType = deleteType;
            this.examRiskWarning = response.message;
            this.confirmExamRisk = true;
            this.isDeleting = false;
        },

        handleDeletedEvent(event) {
            if (event.id !== this.event.id) {
                return;
            }

            this.isDeleting = false;
            this.hide();
        },

        handleDeleteEventFailed(event) {
            if (event.id !== this.event.id) {
                return;
            }

            this.isDeleting = false;
        },
    },
    computed: {
        modalTitle() {
            if (this.confirmExamRisk) {
                return this.texts.required_lesson_warning_title;
            }

            return this.event.is_recurring
                ? this.texts.delete_recurring_event
                : this.texts.delete_event;
        },

        confirmMessage() {
            if (this.confirmExamRisk) {
                return this.texts.required_lesson_warning_description;
            }

            return this.event.is_recurring
                ? this.texts.delete_recurring_event_description
                : this.texts.delete_event_description;
        },

        deleteButtonText() {
            return this.confirmExamRisk
                ? this.texts.delete_anyway
                : this.texts.delete;
        },
    },
    filters: {},
    watch: {},
};
</script>
<style>
.exam-risk-warning {
    text-align: left;
    white-space: normal;
}
</style>
